import {inject, Injectable} from "@angular/core";
import {Translation, TranslocoLoader} from "@jsverse/transloco";
import {HttpClient, HttpContext, HttpContextToken} from "@angular/common/http";
import {catchError, map, switchMap} from "rxjs/operators";
import {throwError} from "rxjs";
import {LanguageService} from '@api-services'

export const PUBLIC = new HttpContextToken<boolean>(() => false);

function expandDotKeys(flat: Record<string, any>): Record<string, any> {
  const result: Record<string, any> = {};
  for (const key of Object.keys(flat)) {
    const parts = key.split('.');
    let current = result;
    for (let i = 0; i < parts.length - 1; i++) {
      if (current[parts[i]] === undefined || typeof current[parts[i]] !== 'object') {
        current[parts[i]] = {};
      }
      current = current[parts[i]];
    }
    current[parts[parts.length - 1]] = flat[key];
  }
  return result;
}

function deepMerge(base: Record<string, any>, override: Record<string, any>): Record<string, any> {
  const result: Record<string, any> = {...base};
  for (const key of Object.keys(override)) {
    if (
      typeof override[key] === 'object' && override[key] !== null &&
      typeof result[key] === 'object' && result[key] !== null &&
      !Array.isArray(override[key])
    ) {
      result[key] = deepMerge(result[key], override[key]);
    } else {
      result[key] = override[key];
    }
  }
  return result;
}

@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);
  private languageService = inject(LanguageService);

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`, {
      context: new HttpContext().set(PUBLIC, true)
    }).pipe(
      switchMap(d =>
        this.languageService.languagesGetFrontendTranslations({code: lang}).pipe(
          map(frontendTransactions => deepMerge(d, expandDotKeys(frontendTransactions as Record<string, any>)))
        )
      ),
      catchError(d => {
        console.log(d);
        return throwError(() => d);
      })
    );
  }
}
